'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

require('slate');

var _getCurrentBlockquote = require('./getCurrentBlockquote');

var _getCurrentBlockquote2 = _interopRequireDefault(_getCurrentBlockquote);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * Is the selection in a blockquote
 */


function isSelectionInBlockquote(opts, value) {
  return Boolean((0, _getCurrentBlockquote2.default)(opts, value));
}

exports.default = isSelectionInBlockquote;